import { BootcampRelease, Faq } from "@/schemaTypes";
import {
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaqsAccordion } from "../Accordion/AccordionFaqs/accordionFaqs";
import { AccordionFaqs } from "../Accordion/utils";
import { PreviousSessions } from "../PreviousSessions/previousSessions";
import { Schedule } from "../Schedule/schedule";
import { BootcampTabsProps } from "./utils";

export const BootcampTabs = ({ bootcamp, isRegistered }: BootcampTabsProps) => {
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const { t } = useTranslation();

  const faqs: AccordionFaqs = {
    data: bootcamp?.release?.faqs as Faq[],
  };

  return (
    <Tabs variant={"black"} isLazy>
      <TabList sx={{ borderBottom: "none" }}>
        <Tab color="neutral.300">{t("Bootcamp schedule")}</Tab>
        {isRegistered && (
          <Tab color="neutral.300">{t("Previous sessions")}</Tab>
        )}
        <Tab color="neutral.300">
          {isMobile ? "FAQs" : t("frequent questions")}
        </Tab>
        <TabIndicator />
      </TabList>
      <TabPanels px={0}>
        <TabPanel px={0}>
          <Schedule
            release={bootcamp?.release as BootcampRelease}
            bootcampType={bootcamp.parent?.bootcampType ?? ""}
          />
        </TabPanel>
        {isRegistered && (
          <TabPanel px={0}>
            <PreviousSessions
              bootcampReleaseId={bootcamp.release?.id ?? ""}
              linkForResources={bootcamp.release?.linkForResources as string}
            />
          </TabPanel>
        )}
        <TabPanel px={0}>
          <FaqsAccordion accordionContent={faqs} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
